import React from 'react';
import "./agent-ui.css";
import { Btn, FormSearch } from '../../utils/utils';
import { Add } from 'iconsax-react';

const AgentHeader = ({header, btnText, placeholder, isSearch, btnClick, btnClick2, btnText2, changeInput}) => {

  return (
    <div className='agent-head'>
        <h3>{header}</h3>
        {isSearch && <FormSearch placeholder={placeholder} changeInput={changeInput} />}
        <div className="agent_btn_cont">
        {btnText2 && <Btn btnText={btnText2} btnClass={"home-btn_trans"} btnClick={btnClick2} leftIcon={<Add size={24} color='#F08228'/>} />}
        {btnText && <Btn btnText={btnText} btnClass={"home-btn"} btnClick={btnClick} leftIcon={<Add size={24} color='white' />} />}
        </div>
    </div>
  )
}

export default AgentHeader